








import { Vue, Component } from 'vue-property-decorator';


@Component({})
export default class Contact extends Vue {


    process(): void {
        console.log(localStorage.getItem('accessToken'))
    }
}

